import { FILTER_TYPES } from 'common/constants/filters';

const AzureBoardsValidationService = () => ({
  handleSync: ({
    doSync,
    sensorAuth,
    setIterationsData,
    setIsLoadingIterations,
    selectedFilters
  }) => {
    const selectedTeamIds = (
      selectedFilters[FILTER_TYPES.AZURE_BOARDS_PROJECT_TEAM_AREAS] || []
    )
      .map(projectTeamArea => projectTeamArea?.team?.id)
      .filter(Boolean);
    if (selectedTeamIds.length) {
      doSync(sensorAuth, selectedTeamIds);
    } else {
      setIterationsData([]);
      setIsLoadingIterations(false);
    }
  },
  isSyncPerEntity: true
});

export default AzureBoardsValidationService;
